
import axios from '../wmsAxios'

// 保存
export const save = (data) => {
    return axios({
        url: '/tblShippingLabel/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblShippingLabel/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblShippingLabel/findPage',
        method: 'post',
      data
    })
}

// 保存
export const generateDelivery = (data) => {
  return axios({
    url: '/tblShippingLabel/generateDelivery',
    method: 'post',
    data
  })
}

// 保存
export const removeFromDelivery = (data) => {
  return axios({
    url: '/tblShippingLabel/removeFromDelivery',
    method: 'post',
    data
  })
}

// 保存
export const shippingByDelivery = (data) => {
  return axios({
    url: '/tblShippingLabel/shippingByDelivery',
    method: 'post',
    data
  })
}

// 获取箱子打印面单的数据
export const getPrintData = (data) => {
  return axios({
    url: '/tblShippingLabel/getPrintData',
    method: 'post',
    data
  })
}

// 申请面单
export const applyShipLabel = (data) => {
  return axios({
    url: '/tblShippingLabel/applyShipLabel',
    method: 'post',
    data
  })
}

// 获取交接单数据
export const getDeliveryData = (data) => {
  return axios({
    url: '/tblShippingLabel/getDeliveryData',
    method: 'post',
    data
  })
}

// 获取发货单数据
export const getDispatchData = (data) => {
  return axios({
    url: '/tblShippingLabel/getDispatchData',
    method: 'post',
    data
  })
}

// 获取装箱清单数据
export const getPackageData = (data) => {
  return axios({
    url: '/tblShippingLabel/getPackageData',
    method: 'post',
    data
  })
}

// 获取托盘标签数据
export const getPalletLabelData = (data) => {
  return axios({
    url: '/tblShippingLabel/getPalletLabelData',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblShippingLabel.js